import useCurrentUserAccount from 'src/hooks/useCurrentUserAccount';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import useWalletContext from 'src/hooks/useWalletContext';
import useFeatureFlagStore from 'src/stores/featureFlag/useFeatureFlagStore';

export const useIsElfaWidgetEligible = () => {
	const isMobileScreenSize = useIsMobileScreenSize();
	const wallet = useWalletContext();
	const currentAccount = useCurrentUserAccount();
	const isElfaWidgetFlagEnabled = useFeatureFlagStore((s) =>
		s.flagEnabled('ENABLE_ELFA_WIDGET')
	);
	const isEligible =
		wallet.connected &&
		currentAccount &&
		!!wallet.publicKey?.equals(currentAccount.authority) &&
		isElfaWidgetFlagEnabled &&
		!isMobileScreenSize;

	return isEligible;
};
